"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.IconWrapper = exports.AbsoluteText = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
var _breakpoints = _interopRequireDefault(require("../../../globals/styles/breakpoints"));
var _styles = require("../../../globals/styles/styles");
var _Link = _interopRequireDefault(require("../../../core/Link"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)(_Link.default, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: pro => pro !== 'isLightTheme',
  target: "eerewvt2"
} : {
  shouldForwardProp: pro => pro !== 'isLightTheme',
  target: "eerewvt2",
  label: "Wrapper"
})(props => {
  const isLightTheme = props.isLightTheme;
  const getBackgroundColor = () => {
    if (props.small) {
      return 'transparent';
    }
    if (props.selected) {
      return isLightTheme ? props.theme.lightAppPickerActiveBackground : props.theme.defaultAppPickerActiveBackground;
    }
    return isLightTheme ? props.theme.lightAppPickerBackground : props.theme.defaultAppPickerBackground;
  };
  return /*#__PURE__*/(0, _react.css)("height:", props.selected ? '70px' : '50px', ";width:", !props.selected ? '50px' : !props.small ? '66px' : 'auto', ";border-radius:8px;position:relative;pointer-events:", props.selected ? 'none' : 'auto', ";background-color:", getBackgroundColor(), ";display:flex;justify-content:center;span{display:flex;flex-direction:column;justify-content:center;align-items:center;}@media screen and (max-width: ", _breakpoints.default.medium, "){height:", props.selected ? '60px' : '48px', ";width:", props.selected ? '55%' : '45%', ";span{flex-direction:row;span{display:inline-block;margin-left:0.5em;}}}&:hover,&:focus{background-color:", getBackgroundColor(), ";}&:focus-visible{outline:", _styles.defaultOutline, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:Wrapper;"));
});
const IconWrapper = exports.IconWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "eerewvt1"
} : {
  target: "eerewvt1",
  label: "IconWrapper"
})(props => {
  const isLightTheme = props.isLightTheme;
  const getBackgroundColor = () => {
    if (props.small) {
      return props.theme.illustrationPrimary10;
    }
    return isLightTheme ? props.theme.lightAppPickerIconBackground : props.theme.defaultAppPickerIconBackgroundColor;
  };
  return /*#__PURE__*/(0, _react.css)("&.selected{display:flex;align-items:center;justify-content:center;border-radius:50%;height:40px;width:40px;background-color:", getBackgroundColor(), ";margin-bottom:0.2em;}" + (process.env.NODE_ENV === "production" ? "" : ";label:IconWrapper;"));
});
const AbsoluteText = exports.AbsoluteText = /*#__PURE__*/(0, _base.default)("span", process.env.NODE_ENV === "production" ? {
  target: "eerewvt0"
} : {
  target: "eerewvt0",
  label: "AbsoluteText"
})(process.env.NODE_ENV === "production" ? {
  name: "1g0dfbk",
  styles: "position:absolute;line-height:normal;bottom:calc(-11px - 5px);opacity:0.75"
} : {
  name: "1g0dfbk",
  styles: "position:absolute;line-height:normal;bottom:calc(-11px - 5px);opacity:0.75",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});